import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useInitData = () => {
  const router = useRouter();

  const { setReferralId, setRouter } = useEnterStore();
  const [isReferralFlow, setIsReferralFlow] = useState(false);

  const fetchReferralDetails = async () => {
    const referralId = router.query?.ri;

    if (referralId) {
      setIsReferralFlow(true);
      setReferralId(referralId ? referralId.toString() : null);
      return;
    }
  };

  useEffect(() => {
    if (router.isReady) {
      fetchReferralDetails();
    }
  }, [router.isReady, router.query?.ri]);

  useEffect(() => {
    setRouter(router);
  }, [router, setRouter]);

  return {
    isReferralFlow,
  };
};
